class AwNewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.button = this.form.querySelector('button[type="submit"]');
    this.errorMessage = this.form.querySelector('.aw-newsletter-form__message--error');
    this.successMessage = this.form.querySelector('.aw-newsletter-form__message--success');

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    this.clearErrors();

    // Honeypot filled — almost certainly a bot. Pretend it worked.
    if (this.form.elements.company && this.form.elements.company.value !== '') {
      this.showSuccess();
      return;
    }

    if (!this.validate()) return;

    this.setLoading(true);

    fetch(this.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: this.form.elements.email.value.trim(),
        name: this.form.elements.name.value.trim(),
        listName: this.dataset.tag || '',
        marketingConsent: true,
      }),
    })
      .then((response) => {
        if (response.ok) {
          this.showSuccess();
          return;
        }
        if (response.status >= 400 && response.status < 500) {
          return response
            .json()
            .then((data) => {
              this.showError(data && data.message ? data.message : this.dataset.errorGeneric);
            })
            .catch(() => this.showError(this.dataset.errorGeneric));
        }
        this.showError(this.dataset.errorGeneric);
      })
      .catch(() => this.showError(this.dataset.errorGeneric))
      .finally(() => this.setLoading(false));
  }

  validate() {
    let valid = true;
    const name = this.form.elements.name;
    const email = this.form.elements.email;
    const consent = this.form.elements.consent;

    if (name.value.trim() === '') {
      this.setFieldError(name, this.dataset.errorRequired);
      valid = false;
    }

    if (email.value.trim() === '') {
      this.setFieldError(email, this.dataset.errorRequired);
      valid = false;
    } else if (!email.checkValidity()) {
      this.setFieldError(email, this.dataset.errorEmail);
      valid = false;
    }

    if (!consent.checked) {
      this.setFieldError(consent, this.dataset.errorConsent);
      valid = false;
    }

    return valid;
  }

  setFieldError(input, message) {
    const field = input.closest('[data-field]');
    const error = field && field.querySelector('.aw-newsletter-form__field-error');
    if (error) {
      error.textContent = message;
      error.hidden = false;
      input.setAttribute('aria-describedby', error.id);
    }
    input.setAttribute('aria-invalid', 'true');
  }

  clearErrors() {
    this.errorMessage.hidden = true;
    this.querySelectorAll('.aw-newsletter-form__field-error').forEach((el) => {
      el.hidden = true;
    });
    this.querySelectorAll('[aria-invalid]').forEach((el) => {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
    });
  }

  setLoading(loading) {
    this.button.disabled = loading;
    this.button.setAttribute('aria-busy', loading ? 'true' : 'false');
    this.button.textContent = loading ? this.dataset.submitting : this.button.dataset.label;
  }

  showSuccess() {
    this.form
      .querySelectorAll('[data-field], .aw-newsletter-form__hp, button[type="submit"]')
      .forEach((el) => {
        el.hidden = true;
      });
    this.errorMessage.hidden = true;
    this.successMessage.hidden = false;
    this.successMessage.focus();
  }

  showError(message) {
    this.errorMessage.textContent = message;
    this.errorMessage.hidden = false;
  }
}

customElements.define('aw-newsletter-form', AwNewsletterForm);
